import { siteInfo } from "@/mocks/siteInfo";

export default function DailyUpdate() {
  return (
    <section className="py-14 md:py-20 bg-accent-100/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <span className="inline-block px-4 py-1.5 bg-background-50 text-foreground-800 text-sm font-medium rounded-full mb-4 whitespace-nowrap">
            每日黑料数据
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight">
            黑料每日
            <br />
            都在刷新
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
          <div className="text-center p-4">
            <p className="text-xs text-foreground-600 mb-1 whitespace-nowrap">日均访客</p>
            <p className="text-3xl md:text-4xl font-heading font-bold text-accent-700 whitespace-nowrap">
              {(siteInfo.stats.dailyVisitors / 10000).toFixed(0)}万+
            </p>
          </div>
          <div className="text-center p-4">
            <p className="text-xs text-foreground-600 mb-1 whitespace-nowrap">累计爆料</p>
            <p className="text-3xl md:text-4xl font-heading font-bold text-accent-700 whitespace-nowrap">
              {(siteInfo.stats.totalArticles / 10000).toFixed(1)}万+
            </p>
          </div>
          <div className="text-center p-4">
            <p className="text-xs text-foreground-600 mb-1 whitespace-nowrap">注册用户</p>
            <p className="text-3xl md:text-4xl font-heading font-bold text-accent-700 whitespace-nowrap">
              {(siteInfo.stats.registeredUsers / 10000).toFixed(0)}万+
            </p>
          </div>
          <div className="text-center p-4">
            <p className="text-xs text-foreground-600 mb-1 whitespace-nowrap">月浏览量</p>
            <p className="text-3xl md:text-4xl font-heading font-bold text-accent-700 whitespace-nowrap">
              {(siteInfo.stats.monthlyPageViews / 100000000).toFixed(1)}亿+
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}